// src/pages/Dashboard/Admin/Inventaire/components/DashboardInventaireHeader.jsx

import React from "react";
import { FaBoxOpen, FaWarehouse } from "react-icons/fa";

export default function DashboardInventaireHeader() {
  return (
    <header className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-5 sm:p-6 lg:p-7">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
                <FaWarehouse />
              </span>

              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  Dashboard administratif
                </p>

                <h1 className="mt-1 text-2xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-3xl">
                  Gestion de l’inventaire
                </h1>
              </div>
            </div>

            <p className="mt-4 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Centralisez le matériel du club, les stocks disponibles, les
              catégories et les notes utiles pour le suivi au quotidien.
            </p>
          </div>

          <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-800/60">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white text-[#013E8E] shadow-sm dark:bg-slate-900 dark:text-indigo-300">
                <FaBoxOpen />
              </span>

              <div>
                <p className="text-sm font-bold text-slate-900 dark:text-white">
                  Stocks & matériel
                </p>
                <p className="text-xs leading-5 text-slate-500 dark:text-slate-400">
                  Visualisation rapide des ruptures et stocks faibles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}